module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "process"
  }, [_c('h3', {
    staticClass: "process__title"
  }, [_vm._v("Как это работает")]), _c('div', {
    staticClass: "process__steps"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('MentoringNumber', {
      key: index,
      attrs: {
        "number": index + 1,
        "text": item,
        "isEnd": _vm.items.length === index + 1
      }
    })
  }), 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d76350c8","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/process/MentoringProcess.vue
// module id = cf62f456680abb6dfd92
// module chunks = 89